import React from 'react'
import { jsPDF } from 'jspdf'

type PdfExportProps = {
    className?: string | null,
    style?: Record<string, string> | null,
    filename: string,
    disabled?: boolean,
    onGenerate: () => jsPDF | Promise<jsPDF>
}

type PdfExportState = {
    loading: boolean
}

export default class PdfExport extends React.Component<PdfExportProps, PdfExportState> {
    constructor(props: PdfExportProps) {
        super(props);

        this.state = {
            loading: false
        };
    }

    getData = () => {
        if (!this.state.loading) {
            this.setState({
                loading: true
            });
            Promise.resolve(this.props.onGenerate())
                .then((doc) => {
                    doc.save(this.props.filename);
                    this.setState({
                        loading: false
                    });
                }).catch(() => {
                    this.setState({
                        loading: false
                    });
                });
        }
    }

    render() {
        const { loading } = this.state;
        return (
            <>
                <button
                    type="button"
                    onClick={this.getData}
                    disabled={loading || this.props.disabled}
                    className={this.props.className ?? undefined}
                    style={this.props.style ?? undefined}
                >
                    {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : undefined}
                    &nbsp;Download
                </button>
            </>);
    }
}
